const isAgencyMatchingCriteria = (agency, userAgencyIds, includeUserAgencies) => {
  const isAgencyIncluded = userAgencyIds.includes(agency.id)
  return includeUserAgencies ? isAgencyIncluded : !isAgencyIncluded
}

export const filterSectorAgencies = (sector, userAgencyIds, includeUserAgencies) => {
  return sector.agencies.filter((agency) => isAgencyMatchingCriteria(agency, userAgencyIds, includeUserAgencies))
}

export const filterPatrimoniesByAgencies = (patrimonies, userAgencyIds, includeUserAgencies = true) => {
  if (!patrimonies || !userAgencyIds) return []

  return patrimonies.filter((patrimony) => {
    const filteredSectors = patrimony.sectors.filter((sector) => {
      const matchingAgencies = filterSectorAgencies(sector, userAgencyIds, includeUserAgencies)
      return matchingAgencies.length > 0
    })

    return filteredSectors.length > 0
  })
}
